
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pemetaan-kompetensi/rencana-pengembangan-diri",
      function () {
        return require("private-next-pages/pemetaan-kompetensi/rencana-pengembangan-diri/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pemetaan-kompetensi/rencana-pengembangan-diri"])
      });
    }
  